import React from 'react'
import { Container, Input, Image, Grid, Icon, Button } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import SecurityIcon from "@mui/icons-material/Security";
import { db } from "../../firebase";
import { NavLink } from "react-router-dom";
import { clientAddCartProduct } from "../../redux/acccionesCart";
import { handleBreakpoints } from "@mui/material/node_modules/@mui/system";

require("dotenv").config();
var userUid = "noregister";
const thanksyou = (props) => {
  // console.log(props);
  // console.log(props.match.params.slugs);

  return (
    <div className="bg-container">
      <div className="ui-vpp-store__logo-container">
        <div className="ui-vpp-store__bg-image productHedadre"></div>
      </div>
      <div>
       
          <div className="bg-containercolor">
            <div id="bodycontent-prodtucto">
              <div className="ui-vpp-store__logo-container"></div>
              <div>
                <div className="breadcrumbebiex">
                  <div className="breadcrumbebiex-container">
                    <h1>Gracias</h1>
                    <NavLink to="/productos/">Volver a productos</NavLink>
                  </div>
                  <div className="bodycontent-prodtucto">
                    <div className="container-producto">
                      <section className="section-content padding-y bg">
                        <div className="container">
                          <article className="card">
                            <div className="card-body">
                              <div className="row">
                                <aside className="col-md-7">
                                

                                <div className="ui-pdp-container-ebiex mt-16 ">
                                    <div className="ui-pdp-container__row ui-pdp-container__row--seller-info">
                                      <div className="ui-box-component ui-box-component-pdp__visible--desktop">
                                        <h3 className="title">
                                        Resumen de compra
                                        </h3>
                                        <div className="ui-seller-info">
                                         
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                           





                                </aside>
           
                              </div>
                            </div>
                          </article>
                          <article className="card mt-5">
                            <div className="card-body">
                              <div className="row">
                          
                          [ Otros productos ]
                              
                              </div>
                              <hr />
                              <p>
                                Referencia a terminos y condiciones, consectetur
                                adipisicing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum.
                              </p>
                            </div>
                          </article>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
      </div>
    </div>
  );
};

export default thanksyou;
